import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavArrowLeft, Page, Shield, Activity, MessageText, WarningCircle } from 'iconoir-react';
import LegalManagement from './LegalManagement';
import GdprManagement from './GdprManagement';
import ActivityLogs from './ActivityLogs';
import SupportTickets from './SupportTickets';
import AdminAlerts from './AdminAlerts';
import '../admin.css';

type TabType = 'legal' | 'gdpr' | 'logs' | 'support' | 'alerts';

const AdminExtendedDashboard: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<TabType>('legal');

  return (
    <div className="admin-extended-dashboard">
      {/* Header */}
      <div className="admin-extended-header">
        <button onClick={() => navigate('/admin/saas')} className="btn-back">
          <NavArrowLeft width={20} height={20} />
          Retour
        </button>
        
        <div className="admin-extended-header-info">
          <h1>Gestion avancée</h1>
          <p>Juridique, RGPD, Logs, Support et Alertes</p>
        </div>
      </div>

      {/* Tabs */}
      <div className="admin-extended-tabs">
        <button
          className={`tab ${activeTab === 'legal' ? 'active' : ''}`}
          onClick={() => setActiveTab('legal')}
        >
          <Page width={20} height={20} strokeWidth={2} />
          Juridique
        </button>
        <button
          className={`tab ${activeTab === 'gdpr' ? 'active' : ''}`}
          onClick={() => setActiveTab('gdpr')}
        >
          <Shield width={20} height={20} strokeWidth={2} />
          RGPD
        </button>
        <button
          className={`tab ${activeTab === 'logs' ? 'active' : ''}`}
          onClick={() => setActiveTab('logs')}
        >
          <Activity width={20} height={20} strokeWidth={2} />
          Logs d'activité
        </button>
        <button
          className={`tab ${activeTab === 'support' ? 'active' : ''}`}
          onClick={() => setActiveTab('support')}
        >
          <MessageText width={20} height={20} strokeWidth={2} />
          Support
        </button>
        <button
          className={`tab ${activeTab === 'alerts' ? 'active' : ''}`}
          onClick={() => setActiveTab('alerts')}
        >
          <WarningCircle width={20} height={20} strokeWidth={2} />
          Alertes
        </button>
      </div>

      {/* Tab Content */}
      <div className="admin-extended-content">
        {activeTab === 'legal' && <LegalManagement />}
        {activeTab === 'gdpr' && <GdprManagement />}
        {activeTab === 'logs' && <ActivityLogs />}
        {activeTab === 'support' && <SupportTickets />}
        {activeTab === 'alerts' && <AdminAlerts />}
      </div>
    </div>
  );
};

export default AdminExtendedDashboard;
